// @flow
import React from "react"
import { type HOC, compose, branch } from "recompose"
import {
  reservationPricingQuery,
  reservationExtensionPricingQuery,
} from "data/reservations/graphql/queries"
import type { User } from "data/user/types"
import withQuery from "hoc/withQuery"
import withOnMount from "hoc/withOnMount"
import withOnNextProps from "hoc/withOnNextProps"
import type { ReservationPricingQueryInput } from "data/reservations/graphql/queries"
import ReservationPricingDetail from "./ReservationPricingDetail"
import ReservationPaymentSummary from "./ReservationPaymentSummary"
import type { OriginalReservation } from "data/reservations/types"
import {
  trackAvailability,
  type Availability,
} from "analytics/availability/analyticsTraits"

const ReservationPricing = ({
  data,
  originalReservation,
  input,
  productGroupName,
  summary,
}) => (
  summary
  ? <ReservationPaymentSummary
    {...data}
    originalReservation={originalReservation}
    input={input}
  />
  : <ReservationPricingDetail
    {...data}
    originalReservation={originalReservation}
    input={input}
    productGroupName={productGroupName}
  />
)

type Outter = {|
  productGroupName: string,
  input: ReservationPricingQueryInput,
  originalReservation: ?OriginalReservation,
  availability?: Availability,
  user: User,
  summary?: boolean,
|}

const enhancer: HOC<*, Outter> = compose(
  branch(
    props => !props.originalReservation,
    withQuery(reservationPricingQuery, {
      variables: props => ({
        input: props.input,
      }),
      // Necessary because of refetch() below. Otherwise it will spin endlessly even though the data has been refetched
      noLoader: true,
    }),
    withQuery(reservationExtensionPricingQuery, {
      variables: props => ({
        input: {
          end: props.input.end,
          // $ExpectError impossible due to branch
          reservationId: props.originalReservation.resId,
        },
      }),
      // Necessary because of refetch() below. Otherwise it will spin endlessly even though the data has been refetched
      noLoader: true,
    }),
  ),
  withOnMount(props => {
    if (props.availability) {
      trackAvailability("Selected Dates", props.availability)
    }
  }),
  withOnNextProps((prev, next) => {
    if (prev.user !== next.user) {
      next.refetch()
    }
  }),
)

export default enhancer(ReservationPricing)



// WEBPACK FOOTER //
// ./src/components/ReservationPricing/index.js